/// <amd-module name="Build/Admin/PoolsList/Components/PoolNameDescriptionSettings" />
import * as React from "react";

import { shortcutCommands } from "VSS/Features/MarkdownEditor/Commands/Shortcut";
import { MarkdownTextField } from "VSS/Features/MarkdownEditor/Components";

import { TextField } from "VSSUI/TextField";

import * as Resources from "Build/Admin/PoolsList/Resources";

export interface IPoolNameDescriptionSettingsProps {
    poolName: string | undefined;
    poolDescription: string | undefined;
    onSettingsChanged(poolName: string | undefined, poolDescription: string | undefined): void;
}

export class PoolNameDescriptionSettings extends React.PureComponent<IPoolNameDescriptionSettingsProps> {

    constructor(props: IPoolNameDescriptionSettingsProps) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <div className="pool-name-description-settings">
                <div className="pool-setting-label">
                    {Resources.PoolNameLabel}
                </div>
                <TextField
                    value={this.props.poolName}
                    placeholder={Resources.NewPoolNameLabel}
                    onChange={(ev, poolName) => this.props.onSettingsChanged(poolName, this.props.poolDescription)} />
                <div className="pool-setting-label">
                    {Resources.PoolDescriptionLabel}
                </div>
                <MarkdownTextField
                    shortcutCommands={shortcutCommands}
                    value={this.props.poolDescription}
                    onChange={poolDescription => this.props.onSettingsChanged(this.props.poolName, poolDescription)}
                    rows={4} />
            </div>
        );
    }
}
